import React, { useState } from "react";
import { format } from "date-fns";
import { is } from "date-fns/locale";
import { AnimatePresence, motion } from "framer-motion";

import useMediaQuery from "../hooks/useMediaQuery";

function MediaNewsBlock({ block }) {
  const news = block?.value?.news || [];
  const totalNews = news.length;
  const [page, setPage] = useState(0);
  const [direction, setDirection] = useState(0);

  const isMobile = useMediaQuery("(max-width: 992px)");
  const itemsPerPage = isMobile ? 1 : 3;
  const startIndex = page * itemsPerPage;
  const visibleItems = news.slice(startIndex, startIndex + itemsPerPage);

  if (totalNews === 0) {
    return <p>No news available.</p>;
  }

  const canGoNext = startIndex + itemsPerPage < totalNews;
  const canGoPrev = page > 0;

  const handleNext = () => {
    if (!canGoNext) return;
    setDirection(+1);
    setPage((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (!canGoPrev) return;
    setDirection(-1);
    setPage((prev) => prev - 1);
  };

  const variants = {
    enter: (dir) => ({
      x: dir > 0 ? 300 : -300, 
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir) => ({
      x: dir < 0 ? 300 : -300, 
      opacity: 0
    })
  };

  return (
    <div className="media-news-block py">
      <div className="container-fluid py-0">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <span className="eyebrow">Í fréttum</span>
              <h2 className="light title">Umfjöllun</h2>
            </div>
            <div className="arrow-container">
              <button
                onClick={handlePrev}
                className={`arrow-btn border-0 ${canGoPrev ? "fade-in" : "fade-out"}`}
              >
                ←
              </button>
              <button
                onClick={handleNext}
                className={`arrow-btn border-0 ${canGoNext ? "fade-in" : "fade-out"}`}
              >
                →
              </button>
            </div>
          </div>
        </div>

        <div className="row position-relative overflow-hidden" style={{ minHeight: 200 }}>
          <AnimatePresence custom={direction} mode="popLayout">
            <motion.div
              key={page}      
              custom={direction} 
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.3 }}
              className="d-flex w-100"
              style={{ position: "absolute" }}
            >
              {visibleItems.map((newsItem, idx) => {
                const { link, title, publish_date } = newsItem.value;
                return (
                  <a
                    key={idx}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`d-grid col-12 ${
                      isMobile ? "col-md-12" : "col-md-4"
                    } mb-24 news-item`}
                  >
                    <h4 className="light">{title}</h4>
                    <span className="font-suisse date align-self-end">
                      {publish_date &&
                        format(new Date(publish_date), "d. MMMM yyyy", {
                          locale: is
                        })}
                    </span>
                    <div className="green-arrow-btn small">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.3335 16H8.66683H5.3335ZM26.6668 16L18.6668 8L26.6668 16ZM26.6668 16L18.6668 24L26.6668 16ZM26.6668 16H12.6668H26.6668Z"
                          fill="#ffffff"
                        />
                        <path
                          d="M5.3335 16H8.66683M26.6668 16L18.6668 8M26.6668 16L18.6668 24M26.6668 16H12.6668"
                          stroke="#ffffff"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                );
              })}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default MediaNewsBlock;
